import authService from '../services/Auth';
import {
   getObjectData,
   storeObjectData,
   removeData,
} from '../services/Storage';

const refreshToken = async () => {
   let sessionData = await getObjectData('auth');

   if (!sessionData || !sessionData.refreshToken) {
      throw new Error('No refresh token available');
   }

   let refToken = await sessionData.refreshToken;

   let payload = {
      refreshToken: refToken,
   };
   return authService
      .ResetToken(payload)
      .then(async (response) => {
         await storeObjectData('auth', response.data);
         return true;
      })
      .catch(async (error) => {
         await removeData('auth');
         return false;
      });
};
export default refreshToken;
